import { UploadTypeEnum } from "../../api/upload/contract/upload.contract";
import { FormGroupCompanyService } from "../../services/forms/form-group-company.service";
import { BaseModel } from "../base.model";

export class Theme extends BaseModel {
  id: number;
  onlineLogo?: string;
  offlineLogo?: string;
  offlineLogoHeight?: number;
  offlineLogoBottomPadding?: number;
  offlineLogoSignedUrl?: string;
  onlineLogoSignedUrl?: string;
  themeOfflineFont?: string;
  themeOnlineFont?: string;
  themeBackgroundImage?: string;
  backgroundImageSignedUrl?: string;
  themeHeaderColour?: string;
  themeHeaderTopBorderColour?: string;
  themeSectionHeaderColour?: string;
  themeProgressBarColour?: string;
  themeStartButtonColour?: string;
  themeNextButtonColour?: string;
  themeBackButtonColour?: string;
  themeNewSurveyButtonColour?: string;
  themeRadioButtonColour?: string;
  themeGradientStartColour?: string;
  themeGradientEndColour?: string;
  themeScaleTrackColour?: string;
  themeScaleTrackSelectedColour?: string;

  /**
   * @description Sets the signed logo URLs and background image URL for the company via an API call
   * @param formGroupCompanyService
   */
  public async setSignedLogoUrls(formGroupCompanyService: FormGroupCompanyService): Promise<void> {
    if (this.onlineLogo) {
      this.onlineLogoSignedUrl = await formGroupCompanyService.getImageSignedUrl(
        this.id.toString(),
        UploadTypeEnum.CompanyOnlineLogo
      );
    }
    if (this.offlineLogo) {
      this.offlineLogoSignedUrl = await formGroupCompanyService.getImageSignedUrl(
        this.id.toString(),
        UploadTypeEnum.CompanyOfflineLogo
      );
    }
    if (this.themeBackgroundImage) {
      this.backgroundImageSignedUrl = await formGroupCompanyService.getImageSignedUrl(
        this.id.toString(),
        UploadTypeEnum.CompanyBackgroundImage
      );
    }
  }
}
